export const ratePlansTab = {
  sectionLabel: {
    title: "Tarifs affichés dans la réservation directe",
    hintHotel:
      "Choisissez les tarifs qui apparaissent pour chaque type de chambre, leur ordre et celui par défaut.",
    hintApartment:
      "Choisissez les tarifs que le client voit, glissez pour réorganiser et marquez celui par défaut.",
  },
  loading: "Chargement des tarifs…",
  empty: {
    apartment: "Aucun tarif configuré pour cette propriété.",
    hotel: "Aucun type de chambre configuré pour cet hôtel.",
    room: "Aucun tarif configuré pour cette chambre.",
  },
  derivedPill: "Dérivé",
  dragHandleTitle: "Glisser pour réorganiser",
  visibleSwitchTitle: "Afficher dans la réservation directe",
  expandTitleClose: "Fermer les paramètres",
  expandTitleOpen: "Définir le nom, la politique et la valeur par défaut",
  visibleNameLabel: "Nom affiché",
  visibleNamePlaceholderApartment: "Ex. : Non remboursable / Flexible",
  visibleNamePlaceholderHotel: "Ex. : Petit-déjeuner inclus",
  cond: {
    refundable: "Annulation possible",
    refundableHint: "Vous décidez jusqu'à quand c'est gratuit.",
    nonRefundable: "Non remboursable",
    nonRefundableHint: "Rien n’est remboursé. Le voyageur peut annuler, mais 100 % lui est facturé. Il le voit avant de payer.",
    freeDays: "Annulation gratuite jusqu'à",
    freeDaysPlaceholder: "Sans limite",
    freeDaysHelp: "Jours avant l'arrivée. Vide = gratuit jusqu'au bout.",
    penalty: "Ensuite, vous facturez",
    penaltyHelp: "Du total du séjour. 100% = rien n'est remboursé.",
    sinGuardar: "Ce tarif n’a pas encore de conditions enregistrées. Ci-dessous, une proposition : appuyez sur « Enregistrer la politique » pour l’appliquer.",
    aplicarTodas: "Appliquer à toutes les chambres",
    aplicarTodasHelp: "La même condition sera appliquée au tarif « {name} » d’1 chambre de plus. | La même condition sera appliquée au tarif « {name} » de {count} chambres de plus.",
    notes: "Notes pour le voyageur (facultatif)",
    previewNonRefundable: "Le voyageur lira : « Ce tarif n'est pas remboursable : la réservation ne peut pas être annulée. »",
    previewFree: "Le voyageur lira : « Annulation gratuite jusqu'à l'arrivée. »",
    previewDayPenalty: "Le voyageur lira : « Annulation gratuite jusqu'au jour de l'arrivée ; ensuite, {pct}% sont facturés. »",
    previewUntilPenalty: "Le voyageur lira : « Gratuit jusqu'à 1 jour avant ; ensuite, {pct}% sont facturés. » | Le voyageur lira : « Gratuit jusqu'à {count} jours avant ; ensuite, {pct}% sont facturés. »",
    shortNonRefundable: "Non remboursable",
    shortFree: "Annulation gratuite",
    shortDayPenalty: "Gratuit jusqu'à l'arrivée · puis {pct}%",
    shortUntilPenalty: "Gratuit jusqu'à 1 jour avant · puis {pct}% | Gratuit jusqu'à {count} jours avant · puis {pct}%",
  },
  cancellationPolicyLabel: "Politique d'annulation",
  policyEmpty: "Aucune politique définie",
  policyEdit: "Modifier",
  policyAdd: "Ajouter",
  defaultLabel: "Par défaut",
  rulesApartment: "Règles : au moins 1 visible et 1 par défaut (qui doit être visible).",
  rulesRoom: "Chaque chambre doit avoir au moins 1 tarif visible et 1 par défaut.",
  tip: 'Conseil : définissez un tarif "Flexible" par défaut et affichez les autres comme "Non remboursable".',
  room: {
    ratePlansCount: "{count} tarif | {count} tarifs",
    includedGuestsTitle: "Nombre de personnes incluses dans le prix (pour le supplément par personne)",
    includes: "Inclut",
    person: "personne | personnes",
    meta: "Capacité : {capacity} • Adultes : {adults} • Enfants : {children}",
  },
  modal: {
    eyebrow: "Politique d'annulation",
    closeAria: "Fermer",
    hint: "Ce texte sera affiché au client lors de la réservation directe. Décrivez les conditions d'annulation de ce tarif.",
    textareaPlaceholder:
      "Ex. : Annulation gratuite jusqu'à 48 h avant le check-in. Passé ce délai, la première nuit est facturée. Non remboursable en haute saison.",
    clear: "Effacer",
    cancel: "Annuler",
    saving: "Enregistrement…",
    save: "Enregistrer la politique",
    defaultTitle: "Tarif",
  },
  toasts: {
    loadError: "Impossible de charger les tarifs.",
    saveSuccess: "Tarifs enregistrés avec succès.",
    saveError: "Impossible d'enregistrer les tarifs.",
  },
  validation: {
    roomMinVisible: 'La chambre "{name}" doit avoir au moins 1 tarif visible.',
    roomOneDefault: 'La chambre "{name}" doit avoir exactement 1 tarif par défaut.',
    roomDefaultVisible: 'Dans "{name}", le tarif par défaut doit être visible.',
    minVisible: "Vous devez conserver au moins 1 tarif visible.",
    oneDefault: "Il doit y avoir exactement 1 tarif par défaut.",
    defaultVisible: "Le tarif par défaut doit être visible.",
  },
};
